import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

import Dialog from '@mui/material/Dialog';
import LoadingButton from '@mui/lab/LoadingButton';
import CloseIcon from '@mui/icons-material/Close';

import DialogContent from '@mui/material/DialogContent';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';

import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import { Select } from '../select';
import { teachersOnboardingTextFields } from '../../_mock';
import { FileUpload } from '../file-upload';

const fieldsNotToInclude = ['createdAt', 'updatedAt', '__v', '_id', 'image', 'siteLeaders'];

export default function AlertDialog({
  open,
  handleClose,

  isLoading,
  schoolToEditData,
  editedSchoolData,
  setEditedSchoolData,
  modifySchool,
}) {
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    watch,
    setValue,
  } = useForm({});

  const [previewImage, setPreviewImage] = useState('');
  const [selectedImage, setSelectedImage] = useState('');

  useEffect(() => {
    if (Object.keys(editedSchoolData).length !== 0) {
      modifySchool();
    }
  }, [editedSchoolData]);

  const onSubmit = (data) => {
    if (selectedImage && selectedImage.size > 10 * 1024 * 1024) {
      toast.error('Resolve the Errors');
      return;
    }
    const formData = new FormData();

    Object.keys(data).forEach((key) => {
      if (fieldsNotToInclude.includes(key) === false) {
        formData.append(key, data[key]);
      }
      if (key === '_id') {
        formData.append('id', data[key]);
      }
    });

    // // if image updated then selected image will be the file
    if (selectedImage) {
      formData.append('image', selectedImage);
    }

    setEditedSchoolData({ formData });
  };

  useEffect(() => {
    reset({ ...schoolToEditData });

    setPreviewImage(schoolToEditData?.image);
  }, [schoolToEditData]);

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          '& .MuiPaper-root': {
            width: { xs: '350px', sm: '649px' },
            height: 'max-content',
            borderRadius: '20PX',
          },
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: '20px' }}>
          <Typography variant="h4" sx={{ color: 'text.titles', }}>
            Edit Partnership Site
          </Typography>
          <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />
        </Box>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            

            <FileUpload
              setPreviewFile={setPreviewImage}
              setSelectedFile={setSelectedImage}
              previewFile={previewImage}
              selectedFile={selectedImage}
            />
            <TextField
              name="name"
              label="Partnership Name"
              placeholder="Partnership Site Here"
              fullWidth
              {...register(
                'name',

                {
                  required: `Partnership Site is required`,
                  maxLength: { value: 30, message: 'School name cannot exceed 70 characters' },
                }
              )}
              error={errors && !!errors?.name}
              helperText={errors?.name?.message}
              type="text"
              sx={{ mb: '17px' }}
            />
            {/* <TextField
              name="address"
              label="address"
              placeholder="Address Here"
              fullWidth
              // {...register('confirmPassword')}
              type="text"
              sx={{ mb: '10px' }}
              {...register(
                'state',

                {
                  required: `Address is required`,
                  maxLength: { value: 70, message: 'Address cannot exceed 70 characters' },
                }

                // { required: `Address is required` }
              )}
              error={errors && !!errors?.state}
              helperText={errors?.state?.message}
            /> */}

            <Select
              register={register}
              field={{ ...teachersOnboardingTextFields[10], label: 'state', name: 'state' }}
              errors={errors}
              name={'state'}
              watch={watch}
              defaultValue={watch('state') || ''}
              onChange={(e) => setValue('state', e.target.value)}
              items={teachersOnboardingTextFields[10].items}
              schoolDistrict
            />
          </DialogContent>

          <Box sx={{ textAlign: 'right', pr: '31px', pb: '37px' }}>
            <LoadingButton
              loading={isLoading}
              variant="contained"
              color="main"
              sx={{ width: '164px', height: '48px', mr: '4px' }}
              type="submit"
            >
              Save
            </LoadingButton>
            <Button
              variant="outlined"
              color="secondary"
              sx={{ width: '164px', height: '48px' }}
              onClick={() => handleClose()}
            >
              Cancel
            </Button>
          </Box>
        </form>
      </Dialog>
    </div>
  );
}
